import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 256 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 256 512\" id=\"icon-facebook\">\r\n  <title id=\"icon-facebook_facebookTitle\">Facebook</title>\r\n<path d=\"M209.3,85H256V3.6C248,2.5,220.2,0,187.9,0C120.5,0,74.4,42.4,74.4,120.3V192H0v91h74.4v229h91.2V283h71.4l11.3-91h-82.7\r\n\tv-62.7C165.5,103,172.6,85,209.3,85L209.3,85z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol